/**
 * Error instance representing an unexpected error, ie should be synonym to "internal error" as HTTP 5XX.
 */

import { HttpStatus, type HttpStatusCode, type UpperSnakeCase } from '../../lib/entry.js';
import { type ErrorCode, PoolbettingError } from './PoolbettingError.js';

export class InternalError<TCode extends string = ErrorCode> extends PoolbettingError<TCode | 'INTERNAL'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.InternalServerError;

  constructor(
    message = 'Request error',
    options?: ErrorOptions,
    code: (TCode & UpperSnakeCase<TCode>) | 'INTERNAL' = 'INTERNAL'
  ) {
    super(message, options, code);
    this.name = 'InternalError';
  }
}
